<template>
  <h2 class="elr-card-title">
    <template v-if="url">
      <router-link :to="url"><slot /></router-link>
    </template>
    <template v-else>
      <slot />
    </template>
  </h2>
</template>

<script>
export default {
  name: 'CardTitle',
  props: {
    url: {
      type: String,
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../assets/sass/config';

.elr-card-title {
  font-size: 24px;
  font-weight: 900;
  padding-bottom: 5px;
  color: $accent-color;

  a {
    color: $accent-color;
    font-weight: 900;
    text-decoration: none;

    &:hover {
      color: lighten($accent-color, 10%);
    }
  }
}
</style>
